import * as React from 'react'

import './ImageContainer.scss'

interface IProps {
  src?: string
}

export default class ImageContainer extends React.Component<IProps> {
  public render() {
    const { src } = this.props

    return (
      <div className="image-container">
        <img className="center" src={src} />
      </div>
    )
  }
}
